<template>
  <div>
    <DocumentHeader header="ใบส่งคืนสินค้า(ลดหนี้แล้ว)" link_back="stock/document/documentreducedebt"/>
    <document_reduce_details/>
  </div>
</template>

<script>
import DocumentHeader from "@/components/admin/document_stock/header_document/DocumentHeader";
import document_reduce_details from "@/components/admin/document_stock/Document_reduce_details";
export default {
  name: "DocumentReduceDetails",
  components: {
    document_reduce_details,
    DocumentHeader
  }
}
</script>

<style scoped>

</style>
